<template>
<div class="marketing-manage">
    <div class="msg-record area-1190">
        <div class="msg-record-title">短信发送记录：</div>
        <div class="msg-record-content clearfix">
            <el-card v-if="index < 4" v-for="(item, index) in msgArr" class="box-card" :key="index">
                <div class="msg-record-item-time">时间：{{item.create_time | formatDate}}</div>
                <el-popover placement="bottom" width="300" title="发送对象" trigger="hover">
                    <el-table :data="item.customer">
                        <el-table-column min-width="50%" property="name" label="姓名"></el-table-column>
                        <el-table-column min-width="50%" property="phone" label="手机号"></el-table-column>
                    </el-table>
                    <div class="msg-record-item-person-num" slot="reference">发送人数：{{item.people_num}}</div>
                </el-popover>
                <el-popover placement="bottom-start" title="短信内容" width="200" trigger="hover" :content="item.text">
                    <div class="msg-record-item-content" slot="reference">发送内容：{{item.shortText}}</div>
                </el-popover>
            </el-card>
            <div class="find-more" @click="findMore">查看更多</div>
        </div>
    </div>
    <div class="marketing-manage-bottom area-1190 clearfix">
        <div class="linkman">
            <div class="linkman-title">选择发送联系人</div>
            <div class="linkman-table">
                <span class="all-select">全选</span>
                <el-table ref="multipleTable" height="455" :data="tableData" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionLinkMan">
                    <el-table-column type="selection" width="100">
                    </el-table-column>
                    <el-table-column prop="name" align="center" label="姓名" min-width="25%">
                    </el-table-column>
                    <el-table-column prop="phone" align="center" label="手机号" min-width="30%">
                    </el-table-column>
                    <el-table-column prop="belong_store_name" align="center" label="所属门店" min-width="45%">
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <div class="show-info-area ">
            <div class="telephone-preview">
                <div class="telephone-preview-title">手机号预览</div>
                <div class="telephone-preview-content">{{telPreviewStr}}</div>
            </div>
            <div class="msg-content">
                <div class="msg-content-title">短信内容</div>
                <div class="msg-content-bottom">
                    <div class="msg-content-info">{{templateStr}}</div>
                    <div class="msg-operator-btn">
                        <span class="get-template" @click="getTemplate">选择模板</span> 
                        <span  class="edit-template" @click="editTemplate">编辑模板</span> 
                        <span  class="now-send-msg" @click="nowSendMsg">立即发送</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="dialog-group">
        <el-dialog title="选择模版" :visible.sync="selectTemplateDialogFormVisible">
            <el-form>
                <el-form-item label="活动区域" :label-width="selectTemplateFormLabelWidth">
                    <el-select v-model="targetTemplateIndex" @change="selectTemplate" placeholder="请选择模版消息...">
                        <el-option v-for="(item, index) in templateArr" :key="index" :label="item.name" :value="index"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="selectTemplateQuit">取 消</el-button>
                <el-button type="primary" @click="selectTemplateOk">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="编辑模版" :visible.sync="editTemplateDialogFormVisible">
            <el-form :model="editForm">
                <el-form-item label="商品名" :label-width="editTemplateFormLabelWidth">
                    <el-input v-model="editForm.product" autocomplete="off" placeholder="请输入商品名..."></el-input>
                </el-form-item>
                <el-form-item label="时间" :label-width="editTemplateFormLabelWidth">
                    <el-input v-model="editForm.time" autocomplete="off" placeholder="请输入时间..."></el-input>
                </el-form-item>
                <el-form-item label="地点" :label-width="editTemplateFormLabelWidth">
                    <el-input v-model="editForm.place" autocomplete="off" placeholder="请输入地点..."></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="editTemplateQuit(editForm)">取 消</el-button>
                <el-button type="primary" @click="editTemplateOk(editForm)">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</div>
</template>

<script>
import Tool from '../../assets/js/Tool.js';
import {mapGetters, mapMutations} from 'vuex';
export default {
    data() {
        return {
            telPreviewStr: "请选择联系人...",
            linkManGridData: [],
            msgArr: [1, 2, 3, 4, 5, 6], 
            tableData: [],
            customerArr: [],
            templateArr: [],
            templateStr: '请点击获取模板选择模板...',
            targetTemplateIndex: '',
            selectTemplateDialogFormVisible: false,
            selectTemplateFormLabelWidth: '120px',
            editTemplateDialogFormVisible: false,
            editTemplateFormLabelWidth: '120px',
            editForm: {
                product: "",
                time: "",
                place: ""
            }
        }
    },
    computed: {
        ...mapGetters(['user'])
    },
    created () {
        this.init();
    },
    methods: {
        init() {
            this.getLinkMan();
            this.getMsgRecord();
        },
        // 获取历史短信记录
        getMsgRecord () {
            this.axios.get('marketing_message')
            .then(res => {
                res.data.data.forEach(item => {
                    item.shortText = Tool.getShortText(item.text, 12) + '......';
                });
                this.msgArr = res.data.data;
            })
        },
        // 查看更多短信记录
        findMore() {
            this.$router.push({
                'name': 'msgrecordall'
            });
        },
        // 获取联系人
        getLinkMan () {
            this.axios.get('customer_list')
            .then(res => {
                this.tableData = res.data.data;
            })
        },
        // 选择联系人
        handleSelectionLinkMan(val) {
            this.telPreviewStr = '';
            val.forEach(item => {
                this.telPreviewStr += item.phone + ', ';
                this.customerArr.push({
                    customer_id: item.id
                });
            });
        },
        // 获取模版
        getTemplate() {
            this.axios.get('message_templatelist')
            .then(res => {
                this.templateArr = res.data.data;
                this.selectTemplateDialogFormVisible = true;
            })
        },
        // 选择模版消息
        selectTemplate() {
            // alert(this.targetTemplateIndex);
        },
        // 确认选择模版
        selectTemplateOk() {
            this.templateStr = this.templateArr[this.targetTemplateIndex].text;
            this.templateStr = Tool.strReplace(this.templateStr, '#name#', 'xxx');
            this.selectTemplateDialogFormVisible = false;
        },
        // 取消选择模版
        selectTemplateQuit() {
            this.targetTemplateIndex = '';
            this.selectTemplateDialogFormVisible = false;
        },
        // 编辑模版
        editTemplate() {
            if(this.templateArr.length == 0) {
                this.$message({
                    type: 'error',
                    message: '未选择模板！'
                });
                return;
            }
            this.editTemplateDialogFormVisible = true;
        },
        editTemplateQuit(form) {
            form.product = '';
            form.time = '';
            form.place = '';
            this.editTemplateDialogFormVisible = false;
        },
        editTemplateOk(form) {
            for (const key in form) {
                this.templateStr = Tool.strReplace(this.templateStr, '#' + key + '#', form[key])
            }
            this.editTemplateDialogFormVisible = false;
        },
        // 发送模版消息
        nowSendMsg() {
            // 判断是否选择联系人
            if(this.customerArr.length == 0) {
                this.$message({
                    type: 'error',
                    message: "未选择联系人！"
                });
                return;
            }
            // 判断是否编辑了模版
            var flag = false;
            for (const key in this.editForm) {
                if(this.editForm[key] != ''){
                    flag = true;
                }
            }
            if(!flag) {
                this.$message({
                    type: 'error',
                    message: '未编辑模板！'
                });
                return;
            }

            var sendObj = {
                user_id: this.user.id,
                t_id: this.templateArr[this.targetTemplateIndex].id,
                message_info: this.editForm,
                customerlist: this.customerArr
            };
            this.axios.post('marketing_message', JSON.stringify(sendObj))
            .then(res => {
                this.$message({
                    type: 'success',
                    message: res.data.msg
                });
            })
        }
    }
}
</script>

<style scoped>
@import url(../../assets/css/base.css);

.msg-record {
    margin-bottom: 30px;
}

.msg-record-title {
    line-height: 67px;
    font-size: 20px;
    font-weight: 700;
}

.msg-record-content {
    position: relative;
}

.box-card {
    position: relative;
    float: left;
    font-size: 16px;
    color: #333;
    text-align: left;
    width: 258px;
    margin-right: 20px;
    border-radius: 8px;
}

.msg-record-item-time {
    font-size: 14px;
    color: #444;
    line-height: 25px;
}

.find-more {
    position: absolute;
    right: 10px;
    top: 60px;
    font-size: 14px;
    color: #448ddf;
    cursor: pointer;
}

.msg-record-item-person-num {
    line-height: 30px;
    cursor: pointer;
}

.msg-record-item-content {
    line-height: 20px;
    cursor: pointer;
}
.marketing-manage-bottom {
    margin-bottom: 40px;
}
.linkman {
    float: left;
    width: 600px;
    margin-right: 50px;
}

.show-info-area {
    float: left;
    width: 448px;
}

.linkman-title {
    width: 100%;
    line-height: 46px;
    text-align: center;
    font-size: 16px;
    color: #fff;
    background-color: #00b662;
    border-radius: 8px 8px 0 0;
}

.linkman-table {
    position: relative;
}

.all-select {
    position: absolute;
    left: 45px;
    top: 12px;
    color: #aaa;
    z-index: 99;
}

.telephone-preview {
    width: 448px;
    margin-bottom: 21px;
}

.telephone-preview-title {
    width: 400px;
    line-height: 46px;
    margin: 0 auto;
    text-align: center;
    font-size: 16px;
    color: #fff;
    background-color: #00b662;
    border-radius: 8px 8px 0 0;
}

.telephone-preview-content {
    height: 130px;
    width: 360px;
    margin: 0 auto;
    background-color: #fff;
    padding: 20px;
    overflow-y: scroll;
    word-wrap:break-word;
}

.msg-content {
    width: 448px;
}

.msg-content-title {
    width: 400px;
    line-height: 46px;
    margin: 0 auto;
    text-align: center;
    font-size: 16px;
    color: #fff;
    background-color: #00b662;
    border-radius: 8px 8px 0 0;
}

.msg-content-bottom {
    height: 220px;
    width: 400px;
    margin: 0 auto;
    background-color: #fff;
    padding-top: 20px;
}

.msg-content-info {
    width: 360px;
    height: 140px;
    padding: 8px;
    margin: 0 auto;
    margin-bottom: 0px;
    border: 1px dashed #ccc;
    margin-bottom: 20px;
    overflow-y: scroll;
}

.msg-operator-btn {
    font-size: 16px;
    color: #3490f8;
    text-decoration: underline;
    padding-left: 10px;
}

.get-template {
    margin-right: 24px;
    cursor: pointer;
}

.edit-template {
    font-size: 16px;
    color: #3490f8;
    cursor: pointer;
}

.now-send-msg {
    display: inline-block;
    width: 120px;
    height: 40px;
    border-radius: 7px;
    background-color: #00b662;
    text-align: center;
    text-decoration: none;
    line-height: 40px;
    margin-left: 100px;
    color: #fff;
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/marketingManage/MarketingManage.vue